<template>
  <v-alert
    v-if="errorMessage"
    v-model="notDismissed"
    class="error-alert rounded-lg text-center pa-2 ma-0"
    style="z-index: 100"
  >
    <div class="d-flex flex-column">
      <div class="d-flex align-center justify-center mb-3">
        <img
          class="error-icon mr-1"
          :src="require('@/assets/icons/attention.svg')"
          alt=""
        />
        <div class="text-center">
          {{ $t("mediaObject.errorUploading") }}
        </div>
      </div>
      <div class="message-container pa-3">
        <div class="error-message mb-2">{{ errorMessage }}</div>
        <div class="try-again">
          {{ $t("mediaObject.pleaseTryAgain") }}
        </div>
      </div>
    </div>
  </v-alert>
</template>
<script>
export default {
  props: {
    errorMessage: String,
    loading: Boolean,
  },
  data() {
    return {
      notDismissed: true,
    };
  },
  watch: {
    loading(newValue) {
      if (newValue) {
        this.notDismissed = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.error-alert {
  position: relative;
  border-radius: 10px;
  border: 1px solid var(--v-backgroundExtraLight-base);
  background: var(--v-inputBackground-base);
  color: var(--v-error-base);
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: $font-spacing;
}

.error-icon {
  width: 18px;
  height: 18px;
}

.message-container {
  border-radius: 10px;
  border: 1px solid var(--v-error-base);
  background: var(--v-errorBackground-base);
}

.error-message, .try-again {
  color: var(--v-error-base);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: $font-spacing;
}

.try-again {
  color: var(--v-secondaryText-base);
}
</style>
